import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Row, Col } from 'reactstrap';
import axios from 'axios';
import { BASE_URL, USER_PERMISSIONS_LABELS } from '../../../constants';
import Select from 'react-select';

function EditUser() {
	const [errMsg, setErrMsg] = useState(null);
	const [formData, setFormData] = useState({
		first_name: '',
		last_name: '',
		email: '',
		// password: '',
		// confirm_password: '',
		phone: '',
		dp: null,
		status: ''
	});
	const [accessAllProperties, setAccessAllProperties] = useState(1);
	const [permissions, setPermissions] = useState([]);
	const [properties, setProperties] = useState([]);
	const [selectedProperties, setSelectedProperties] = useState([]);

	const navigate = useNavigate();
	const { id } = useParams();

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/property/all`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setProperties(data.result.map((property) => ({
							label: property.name,
							value: property.id
						})));
					}
					else {
						console.error("Error: Unable to fetch property data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	}, []);
	
	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/user/details/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (!data.status) {
						return;
					}

					setFormData({
						first_name: data.result.first_name,
						last_name: data.result.last_name,
						email: data.result.email,
						phone: data.result.phone,
						status: data.result.status
					});

					if (data.result.hasOwnProperty('assign_properties') && data.result.assign_properties.length > 0) {
						// setAccessAllProperties(0);
						setSelectedProperties(data.result.assign_properties);
					}

					if (data.result.hasOwnProperty('user_permissions')) {
						if (data.result.user_permissions.hasOwnProperty('access_all_properties')) {
							setAccessAllProperties(data.result.user_permissions.access_all_properties);
						} else {
							setAccessAllProperties(1);
						}

						if (data.result.user_permissions.hasOwnProperty('permissions')) {
							setPermissions(data.result.user_permissions.permissions);
						}
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	}, []);

	const handleFileChange = (e) => {
		setFormData({
			...formData,
			dp: e.target.files[0]
		});
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value
		});
	};

	const handleSubmit = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const newFormData = new FormData();
			newFormData.append('first_name', formData.first_name);
			newFormData.append('last_name', formData.last_name);
			newFormData.append('phone', formData.phone);
			newFormData.append('email', formData.email);
			// newFormData.append('password', formData.password);
			// newFormData.append('confirm_password', formData.confirm_password);
			newFormData.append('status', formData.status);
			newFormData.append('access_all_properties', accessAllProperties);
			newFormData.append('permissions', permissions.join(','));

			if (formData.dp) {
				newFormData.append('dp', formData.dp);
			}

			if (accessAllProperties === 0) {
				newFormData.append('assign_properties', selectedProperties.join(','))
			}

			const response = await axios.put(`${BASE_URL}/user/update/${id}`, newFormData, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			if (response.data.status) {
				navigate('/user');
			}
			else {
				setErrMsg(response.data.message);
			}
		} catch (error) {
			setErrMsg(error);
		}
	};

	return (
		<div className="content">
			{errMsg && <Alert color="danger">{errMsg}</Alert>}

			<h3>Edit User</h3>
			<Card>
				<CardBody>
					<div>
						<Row>
							<Col xs="6">
								<FormGroup>
									<Label for="first_name">First Name*</Label>
									<Input type="text" name="first_name" id="first_name" value={formData.first_name} onChange={handleChange} />
								</FormGroup>
							</Col>

							<Col xs="6">
								<FormGroup>
									<Label for="last_name">Last Name*</Label>
									<Input type="text" name="last_name" id="last_name" value={formData.last_name} onChange={handleChange} />
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col xs="6">
								<FormGroup>
									<Label for="email">Email*</Label>
									<Input type="email" name="email" id="email" value={formData.email} onChange={handleChange} />
								</FormGroup>
							</Col>

							<Col xs="6">
								<FormGroup>
									<Label for="phone">Phone</Label>
									<Input type="number" name="phone" id="phone" value={formData.phone} onChange={handleChange} />
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col xs="6">
								<FormGroup>
									<Label for="status">Status</Label>
									<Input type="select" name="status" id="status" value={formData.status} onChange={handleChange}>
										<option value="">Select Status</option>
										<option value="ACTIVE">ACTIVE</option>
										<option value="INACTIVE">INACTIVE</option>
									</Input>
								</FormGroup>
							</Col>
						</Row>

						<FormGroup>
							<Label for="dp">Profile Picture</Label>
							<Input type="file" name="dp" id="dp" onChange={handleFileChange} />
						</FormGroup>

						<Row>
							<Col>
								<h5 className='mt-2'>Property Access</h5>
								<FormGroup>
									<Label>
										<Input type="radio" name='accessAllProperties' checked={accessAllProperties == 1} onChange={(e) => setAccessAllProperties(1)} />{' '}
										Access All Properties
									</Label>
								</FormGroup>
								<FormGroup>
									<Label>
										<Input type="radio" name='accessAllProperties' checked={accessAllProperties == 0} onChange={(e) => setAccessAllProperties(0)} />{' '}
										Access Selected Properties
									</Label>
								</FormGroup>

								{(accessAllProperties === 0) ? (
									<FormGroup>
										<Label for="property">Assign Properties</Label>
										<Select
											name="assign_properties"
											id="assign_properties"
											isDisabled={accessAllProperties == 1}
											options={properties}
											value={[...properties.filter(property => selectedProperties.includes(property.value))]}
											onChange={(option) => {
												setSelectedProperties(option.map(o => o.value));
											}}
											placeholder="Search and select property"
											isMulti={true}
										/>
									</FormGroup>
								) : null}
							</Col>
							<Col>
								<h5 className='mt-2'>Permissions</h5>
								{[...Object.keys(USER_PERMISSIONS_LABELS)].map((permission, i) => {
									return (
										<FormGroup key={i}>
											<Label>
												<Input type="checkbox" checked={permissions.includes(permission)} onChange={() => {
													if (permissions.includes(permission)) {
														setPermissions(permissions.filter(p => p !== permission));
													} else {
														setPermissions([...permissions, permission]);
													}
												}} />{' '}
												{USER_PERMISSIONS_LABELS[permission]}
											</Label>
										</FormGroup>
									)
								})}
							</Col>
						</Row>

						<Button color="primary" type="button" onClick={handleSubmit}>Submit</Button>
					</div>
				</CardBody>
			</Card>

		</div>
	);
}

export default EditUser;
